import React from 'react'

import './onlineAiClub.css'
import { Link } from 'react-router-dom'
import { DataResources } from './constent'


const ResourcesRepository = () => {
    console.log(DataResources , "DataResources");
    
 
  return (
    <div className='resources-repository py-5 mt-5'>
        <div className='container mt-5'>
        <div className='row'>

       
        {DataResources?.map((item) => {
    // Limit title
    const maxTitleWords = 10; // Example: limit to 5 words
    const titleWords = item?.heading?.split(' ');
    const shortTitle = titleWords?.length > maxTitleWords 
        ? titleWords?.slice(0, maxTitleWords).join(' ') + '...' 
        : item?.heading;

    return (
        <>
            <div className="col-md-4 mb-4">
                <div className="card">
                    <img src={item?.img} className="card-img-top" alt="..." />
                    <div className="card-body p-0">
                        <h5 className="card-title p-3">{shortTitle}</h5>
                        
                        {item?.content.length > 0 && (() => {
    const maxWords = 35;
    let totalWords = 0;
    let finalParas = [];

    for (let i = 0; i < item?.content.length; i++) {
        const para = item?.content[i];
        const words = para?.split(' ');

        if (totalWords < maxWords) {
            const remainingWords = maxWords - totalWords;

            if (words.length <= remainingWords) {
                // Add full para
                finalParas.push(para);
                totalWords += words.length;
            } else {
                // Add partial para to complete limit
                const partial = words.slice(0, remainingWords).join(' ') + '...';
                finalParas.push(partial);
                totalWords += remainingWords;
            }
        } else {
            break; // limit poora ho gaya
        }
    }

    const finalHTML = finalParas.join('<br/>');

    return (
        <>
            <p
                className="card-text px-3"
                dangerouslySetInnerHTML={{ __html: finalHTML }}
            ></p>
            <Link to={`/resources-repository/${item.name}`} className="btn btn-primary">
                Read more
            </Link>
        </>
    );
})()}

                    </div>
                </div>
            </div>
        </>
    );
})}



</div>



    </div></div>
  )
}

export default ResourcesRepository